import { render, staticRenderFns } from "./event-form.vue?vue&type=template&id=5f9686f8&scoped=true&"
import script from "./event-form.vue?vue&type=script&lang=js&"
export * from "./event-form.vue?vue&type=script&lang=js&"
import style0 from "./event-form.vue?vue&type=style&index=0&id=5f9686f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f9686f8",
  null
  
)

export default component.exports